export class UniqueIdGenerator {

    private static currentId: number = 1000; // 从 4 位数开始
    private static lastTimestamp: number = Date.now();
    private static readonly maxIncrement: number = 999; // 每毫秒最多生成 1000 个 ID
    private static increment: number = 0;

    static generateNewId(): number {
        const timestamp = Date.now();

        if (timestamp === UniqueIdGenerator.lastTimestamp) {
            UniqueIdGenerator.increment++;
            if (UniqueIdGenerator.increment > UniqueIdGenerator.maxIncrement) {
                // 等待下一毫秒
                while (Date.now() <= timestamp) { }
                return UniqueIdGenerator.generateNewId();
            }
        } else {
            UniqueIdGenerator.increment = 0;
            UniqueIdGenerator.lastTimestamp = timestamp;
        }

        const timeComponent = timestamp % 1000000; // 取时间戳的后 6 位
        const id = timeComponent * 1000 + UniqueIdGenerator.increment + UniqueIdGenerator.currentId;

        return id;
    }

    static resetCurrentId(): void {
        UniqueIdGenerator.currentId = Math.max(UniqueIdGenerator.currentId, 1000);
    }

    static generateNewStringId(): string {
        return UniqueIdGenerator.generateNewId().toString();
    }

    static generateNewIdList(qty: number = 1): Array<number> {
        return Array.from({ length: qty }, () => UniqueIdGenerator.generateNewId());
    }

    generateId(): number {
        return UniqueIdGenerator.generateNewId();
    }

    generateStringId(): string {
        return UniqueIdGenerator.generateNewId().toString();
    }

    static getCurrentId(): number {
        return UniqueIdGenerator.currentId;
    }
}